module.exports = "https://cdn.realtymogul.com/static/media/mr2_assets.a822817c.png";